import React from 'react'
import { graphql } from 'gatsby'
import { Container, Col, Row } from 'reactstrap'

import SiteDocumentations from '../../../components/SiteDocumentations'

import SEO from '../../../components/seo'

import Rewatec from './rewatec.png'

class rewatec extends React.Component {
  render() {
    const seoData = {
      title: "Documentation produits d'irrigation Rewatec",
      description: "Consultez notre documentation des produits d'irrigation Rewatec",
      coverImage: Rewatec,
      path: this.props.location.pathname,
      schemaOrg: ''
    }

    return (
      <div>
        <SEO seoData={seoData} />
        <Container>
          <Row style={{alignItems: "center", marginBottom: 10}}>
            <Col lg={2} md={2} xs={6}>
              <img src={Rewatec} alt="Rewatec"/>
            </Col>
            <Col lg={10} md={10} xs={12}><h1>Manuels d’instruction Rewatec</h1></Col>
          </Row>
          <SiteDocumentations {...this.props} />
        </Container>
      </div>
    )
  }
}

export default rewatec

export const rewatecDocumentationQuery = graphql`
  query RewatecDocumentation {
    site {
      meta: siteMetadata {
        title
        description
        url: siteUrl
        author
      }
    }
    remark: allMarkdownRemark(
      filter: { frontmatter: { vendor: { eq: "Rewatec" } } }
    ) {
      documentations: edges {
        documentation: node {
          id
          html
          frontmatter {
            layout
            title
            path
            coverImage {
              childImageSharp {
                fluid(maxWidth: 400) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
      }
    }
  }
`
